import * as React from "react";
import * as _ from "lodash";
import { PhoneInputBox, InputFieldMainContainer, Hyphen, Input } from './styles';
import { retry } from "redux-saga/effects";
import { SIZE } from "common/sizes";
import { CSSProperties } from "react";

export interface InputFieldProps {
    value?: string
    type?: string
    style?: CSSProperties
    onChange?: (value: string) => void 

}

const InputField = (props: InputFieldProps) => {
    const [phoneFst, setPhoneFst] = React.useState<string>(props.value ? props.value.substring(0, 3) : "")
    const [phoneSnd, setPhoneSnd] = React.useState<string>(props.value ? props.value.substring(3, 6) : "")
    const [phoneTrd, setPhoneTrd] = React.useState<string>(props.value ? props.value.substring(6, 10) : "")
    const [phoneAll, setPhoneAll] = React.useState<string>(props.value ? props.value : "")
    
    if (props.type =="1")
    {
        return (
            <InputFieldMainContainer>
            <PhoneInputBox style={props.style? props.style:{"width":SIZE.TWENTY_SEVEN+"px"}}>
                <Input                    
                    onChange={(e) => {onInputChange(e, 'all')}}
                    value={ phoneAll }
                    style={props.style? props.style:{"width":SIZE.TWENTY_SEVEN+"px"}}
                />
            </PhoneInputBox>
            </InputFieldMainContainer>
        )

    }
    else
    {   

    return (
        
        
        <InputFieldMainContainer>
            <PhoneInputBox>
                <Input
                    maxLength={5}
                    onChange={(e) => {onInputChange(e, 'first')}}
                    value={"(" + phoneFst + ")"}
                />
            </PhoneInputBox>
            <Hyphen>
                -
            </Hyphen>
            <PhoneInputBox>
                <Input
                    maxLength={3}
                    onChange={(e) => {onInputChange(e, 'second')}}
                    value={phoneSnd}
                />
            </PhoneInputBox>
            <Hyphen>
                -
            </Hyphen>
            <PhoneInputBox>
                <Input
                    maxLength={4}
                    onChange={(e) => {onInputChange(e, 'third')}}
                    value={phoneTrd}
                />
            </PhoneInputBox>
        </InputFieldMainContainer>

    )
    }

    function onInputChange(event, position) {
        const value = event?.target?.value.replace("(", "").replace(")", "") ?? ""
        let livePhone

        switch(position) { 
            case 'first': { 
                livePhone = value + phoneSnd + phoneTrd
                setPhoneFst(value)
                break; 
            } 
            case 'second': { 
                livePhone = phoneFst + value + phoneTrd
                setPhoneSnd(value)
                break; 
            } 
            case 'third': { 
                livePhone = phoneFst + phoneSnd + value
                setPhoneTrd(value)
                break; 
             }
             case 'all': { 
                livePhone = value
                setPhoneAll(value)
                break; 
             }
         } 
        
        if (props.onChange) {
            props.onChange(livePhone)
        }
    }
}

export default InputField;